module.exports = __webpack_public_path__ + "img/icon-home-re-01.d02e49e2.jpg";